import { ChevronLeftIcon, XMarkIcon } from "@heroicons/react/24/outline";
import Drawer from "../commons/Drawer";
import { WalletItem } from "../dashboard/ExchangeWallet";
import CardAvailableExchangeSkeleton from "../cards/skeletons/CardAvailableExchangeSkeleton";

const DrawerExchangeWallet = ({
  isOpen,
  onClose,
  wallets,
  onConnectApiClick,
  loading,
}) => {
  return (
    <>
      {/* Panel Drawer */}
      <Drawer open={isOpen} width="600px" onClose={onClose}>
        <div className="flex flex-col h-full">
          {/* Header Drawer */}
          <div className="flex items-center justify-between w-full md:px-3">
            <button
              className="bg-transparent hover:bg-transparent text-[#007A78] flex !p-0"
              onClick={onClose}
            >
              <ChevronLeftIcon className="w-[20px] h-[20px]" /> Back
            </button>
            <h2 className="text-base md:text-xl font-bold ">Connect an Exchange</h2>
            <button
              className="bg-transparent hover:bg-transparent text-black !p-0"
              onClick={onClose}
            >
              <XMarkIcon className="w-[20px] h-[20px]" />
            </button>
          </div>
          {/* Info Message */}

          <div className="mt-5 mb-3 md:mb-0 md:p-3">
            <div className="bg-[#8BC3FF26]/15 border border-sky-200 text-[#21272A]/60 p-3 rounded-lg text-xs flex items-center">
              <img src={"/images/icons/icon_info.svg"} className="w-5 mr-2" />{" "}
              Exchange Wallet is available based on your country of residence.
            </div>
          </div>

          {/* Daftar Wallet (Scrollable) */}
          <div className="flex-grow overflow-y-auto md:p-3 space-y-5">
            {loading
              ? [...Array(5)].map((_, idx) => (
                  <CardAvailableExchangeSkeleton
                    key={idx + "skeleton-available"}
                  />
                ))
              : wallets?.map((wallet) => (
                  <WalletItem
                    key={wallet.id}
                    wallet={wallet}
                    // Meneruskan prop 'onConnectApiClick' yang diterima dari parent (ExchangeWalletSection)
                    // ke setiap WalletItem.
                    onConnectApiClick={onConnectApiClick}
                  />
                ))}
          </div>
        </div>
      </Drawer>
    </>
  );
};

export default DrawerExchangeWallet;
